import { DQDashboardResponse } from "@/app/models/dqDashboard/types";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersViewfinder } from "@fortawesome/free-solid-svg-icons";

const QuickLookCard: React.FC<{ data?: DQDashboardResponse }> = ({ data }) => (
  <Card
    variant="outlined"
    sx={{
      borderRadius: "10px",
      border: "2px solid #e6ecf0",
    }}
  >
    <CardContent sx={{ py: 2, px: 3 }}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
        <Grid item xs={12} md={3} lg={3}>
          <Stack direction="row" alignItems="center" spacing={1.2}>
            <Box className="iconHeader">
              <FontAwesomeIcon
                icon={faUsersViewfinder}
                color="#666666"
                size="sm"
              />
            </Box>
            <Typography
              sx={{ fontWeight: 700, fontSize: "14px", color: "#494440" }}
            >
              Quick Look
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} md={3} lg={3}>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: 400 }}
          >
            Account Number:
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, color: "#494440" }}
          >
            {data?.isSapSource
              ? data?.sapCustomerNumber
              : data?.customerNumber || "N/A"}
          </Typography>
        </Grid>

        <Grid item xs={12} md={3} lg={3}>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: 400 }}
          >
            Your Lansing Representative:
          </Typography>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            flexWrap="wrap"
          >
            <Typography
              variant="subtitle1"
              sx={{ color: "#494440", fontWeight: 700 }}
            >
              {data?.salesRepName || "N/A"}
            </Typography>
            {data?.salesRepEmail ? (
              <Link
                href={`mailto:${data.salesRepEmail}`}
                underline="none"
                sx={{ fontWeight: 600, color: "#54afe2" }}
              >
                CONTACT
              </Link>
            ) : data?.salesRepPhone ? (
              <Link
                underline="none"
                href={`tel:${data.salesRepPhone}`}
                sx={{ fontWeight: 600, color: "#54afe2" }}
              >
                CONTACT
              </Link>
            ) : data?.warehouseEmail ? (
              <Link
                underline="none"
                href={`mailto:${data.warehouseEmail}`}
                sx={{ fontWeight: 600, color: "#54afe2" }}
              >
                CONTACT
              </Link>
            ) : null}
          </Stack>
        </Grid>

        <Grid item xs={12} md={3} lg={3}>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: 400 }}
          >
            Your Home Branch:
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ color: "#494440", fontWeight: 700 }}
          >
            {data?.warehouse || "N/A"}
          </Typography>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default QuickLookCard;
